/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable import/order */
import { CloseOutlined, DeleteTwoTone } from '@ant-design/icons'
import { Button, Form, Input, notification, Space, Spin, Tabs } from 'antd'
import dayjs from 'dayjs'
import React, {
  ChangeEvent,
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { NoteElement } from '@components'
import { ticketStatusToDisablePrimaryButtonforAdmin } from '@constants'
import { useGeneral, useHandleDeleteTicketModal, useHandleTicketModal, useUser } from '@contexts'
import { useConfigurationProperties, useNote, useTicketsById } from '@hooks'
import {
  AssignationValues,
  CommonTicketForm,
  DeliveryNote,
  Note,
  RoleEnum,
  StatusTicketEnum,
  Ticket,
  TripTypeEnum,
} from '@types'
import { CutoffTimeUtils, DeliveryNoteUtils } from '@utils'

import UpdateTicketFormAdmin from './UpdateTicketFormAdmin'
import RedirectToTicket from '../../../components/RedirectToTicket'
import ShareTicket from '../../../components/ShareTicket'
import { FlexRow, StyledButton, StyledModal } from '../../../components/StyledComponents'
import { StyledRow } from '../../Login/components'

const { TextArea } = Input

const { ADMIN, ADMINRO } = RoleEnum
const { TICKET, PURCHASES } = QUERY_KEYS

const adminRoles = [ADMIN, ADMINRO]
const ableRolesToShare = [...adminRoles]
const { CREATED, CANCELED } = StatusTicketEnum

// Admin puede eliminar tickets en cualquier estado excepto CANCELED
// Sin importar la fecha (pasados, presentes o futuros)
const canAdminDeleteTicket = (status: StatusTicketEnum | undefined): boolean =>
  status !== undefined && status !== CANCELED

const primaryButtonInitialStateByRole = (ticket: Ticket) => ({
  [ADMIN]: ticketStatusToDisablePrimaryButtonforAdmin.includes(
    ticket.status.name as StatusTicketEnum,
  ),
})

const today = dayjs()
const tomorrow = today.clone()
tomorrow.add(1, 'day').startOf('d')

type TabValue = '1' | '2'

type Props = {
  onOk: (
    id: number | undefined,
    form: CommonTicketForm,
    resetForm: () => void,
    dates: Date[] | undefined,
    toApprove?: boolean | undefined,
  ) => void
  title: string
  isLoading: boolean
  onClose: (reset?: () => void) => void
}

const UpdateTicketModalAdmin: React.FC<Props> = ({ onClose, title, onOk, isLoading }) => {
  const { t } = useTranslation()
  const { roles } = useUser()
  const queryClient = useQueryClient()
  const { ticketById, isTicketByIdLoading } = useTicketsById()
  const { setIsDeleteTicketModalOpen } = useHandleDeleteTicketModal()
  const { ticketToEdit, setTicketToEdit, setIsTicketModalOpen, isTicketModalOpen } =
    useHandleTicketModal()
  const {
    assignmentTickets,
    carrierAvailabilityIsEnabled,
    maxAllowedDaysForSupplierRequest,
    cutoffTimeHour,
  } = useConfigurationProperties()
  const { addNote } = useNote()
  const [form] = Form.useForm()
  const [formNotes] = Form.useForm()
  const { setFormInstance } = useGeneral()
  const [editable, setEditable] = useState<boolean>()
  const [isWarning, setIsWarning] = useState<boolean>()
  const [assignValue, setAssignValue] = useState<AssignationValues>()
  const [ifToApproved, setIfToApproved] = useState<boolean>()
  const [dates, setDates] = useState<Date[]>()
  const [primaryButtonIsDisabled, setPrimaryButtonIsDisabled] = useState<boolean>()
  const [activeTab, setActiveTab] = useState<TabValue>()
  const [noteContent, setNoteContent] = useState<string>()

  const handleSetNoteContent = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setNoteContent(e.target.value)
  }

  const handlePrimaryButtonDisabling = (value: boolean) => {
    setPrimaryButtonIsDisabled(!!value)
  }

  const resetModal = useCallback(() => {
    setTicketToEdit(0)
    setIsTicketModalOpen(false)
    queryClient.removeQueries([TICKET, PURCHASES])
    notification.destroy('validationError')
    // self states
    setEditable(undefined)
    setIsWarning(undefined)
    setAssignValue(undefined)
    setIfToApproved(undefined)
    setDates(undefined)
    setPrimaryButtonIsDisabled(undefined)
    setActiveTab(undefined)
    setNoteContent(undefined)
  }, [ticketToEdit])

  const handleCloseModal = () => {
    onClose()
  }

  const handleAfterModalClose = () => {
    setDates(undefined)
  }

  const defaultAssignValue = useMemo(
    () => (assignmentTickets === 'true' ? 'automatic' : 'manual'),
    [assignmentTickets],
  )
  const cutoffTime = useMemo(
    () =>
      typeof cutoffTimeHour === 'number' && !Number.isNaN(cutoffTimeHour)
        ? `${String(cutoffTimeHour).padStart(2, '0')}:00`
        : CutoffTimeUtils.getCutoffTime(),
    [cutoffTimeHour],
  )

  const ticketModalHeader = useCallback(() => {
    const modalTitle = ticketToEdit
      ? `${t('globals.generics.request')}${
          ticketById?.ticket?.id ? ` #${ticketById?.ticket?.id}` : ''
        }${
          ticketById?.ticket?.status.name
            ? ` - ${t(`globals.generics.status.${ticketById?.ticket?.status.name.toLowerCase()}`)}`
            : ''
        }`
      : title
    if (
      roles?.includes(ADMIN) &&
      !!(ticketById && canAdminDeleteTicket(ticketById?.ticket?.status?.name as StatusTicketEnum))
    ) {
      return modalTitle
    }
    if (
      roles?.includes(ADMINRO) &&
      !!(ticketById && canAdminDeleteTicket(ticketById?.ticket?.status?.name as StatusTicketEnum))
    ) {
      return modalTitle
    }
    return modalTitle
  }, [ticketToEdit, ticketById, roles])

  const DinamicTitle: React.FC<PropsWithChildren> = useCallback(
    ({ children }) => (
      <Space className="ticket-modal-header-tools">
        {children}
        {ticketById?.ticket?.id && roles && roles.some(item => ableRolesToShare.includes(item)) && (
          <FlexRow style={{ marginTop: '-6px' }}>
            <RedirectToTicket ticketId={ticketById.ticket.id} />
            <ShareTicket ticketId={ticketById.ticket.id} />
          </FlexRow>
        )}
      </Space>
    ),
    [ticketById, roles],
  )

  const proceed = useCallback(() => {
    if (dates?.length === undefined) {
      setIsWarning(true)
    }
    form.setFieldsValue({ datesInput: dates?.length ? true : undefined })
    form
      .validateFields()
      .then(values => {
        const isVirgin =
          ticketToEdit === 0 ||
          (ticketById?.ticket?.status.name === CREATED &&
            !ticketById.ticket.ticketAssignments?.length)
        const deliveryNoteNumber = DeliveryNoteUtils.normalizeValue(values.number)
        const deliveryNote: DeliveryNote | undefined = deliveryNoteNumber
          ? {
              number: deliveryNoteNumber,
              ...(values.observation ? { observation: values.observation } : {}),
            }
          : undefined
        const isCfr = values.tripType === TripTypeEnum.CFR
        onOk(
          ticketById?.ticket?.id,
          {
            ...(deliveryNote && { deliveryNote }),
            count: values.count,
            depotId: values.depotId,
            materialId: values.materialId,
            equipmentId: values.equipmentId,
            destinationId: values.destinationId,
            carrierId: values.carrierId,
            note: values.comments ? { description: values.comments } : undefined,
            documentNumberId: values.documentNumberId ?? undefined,
            type: isVirgin ? assignValue || (assignmentTickets ? 'automatic' : 'manual') : 'manual',
            declinedLoad: values.declinedLoad,
            declinedLoadType: values.declinedLoadType,
            tripType: values.tripType,
            ticketSap:
              typeof values.ticketSap === 'string' && /^\d+$/.test(values.ticketSap)
                ? values.ticketSap
                : null,
            ...(!isCfr && { sapItemId: values.sapItemId }),
            // [CONTRACT_LINE_FIELD_NAME]: values[CONTRACT_LINE_FIELD_NAME],
          },
          () => {
            // No cerrar el modal aquí, se cerrará desde onSuccess del submitHandler
            // Esto permite que el loading se muestre y se espere la respuesta del backend
          },
          dates,
          !!ifToApproved,
        )
      })
      .catch(e => {
        console.log('e :>> ', e)
        notification.destroy('validationError')
        notification.error({
          message: t('globals.validation_error'),
          key: 'validationError',
        })
      })
  }, [dates, ticketToEdit, ticketById, assignmentTickets, assignValue, ifToApproved])

  const handleAddNote = useCallback(() => {
    formNotes
      .validateFields()
      .then(({ note }) => {
        addNote({ id: ticketToEdit!, note: { description: note } })
        setNoteContent('')
        formNotes.resetFields()
      })
      .catch(() => {
        notification.error({
          message: 'Revise el campo de agregar notas, formato no permitido.',
        })
      })
  }, [ticketToEdit, noteContent])

  useEffect(() => {
    if (roles) {
      if (ticketById?.ticket) {
        setAssignValue(!!ticketById.ticket?.autoAssign ? 'automatic' : 'manual')
        setIfToApproved(!!(roles.includes(ADMIN) && ticketById.ticket?.status.name === CREATED))
        handlePrimaryButtonDisabling(
          roles.includes(ADMIN) ? primaryButtonInitialStateByRole(ticketById.ticket)[ADMIN] : true,
        )
        setIsTicketModalOpen(true)
      }
    }
  }, [ticketById, roles])

  useEffect(() => {
    if (!isTicketModalOpen) {
      resetModal()
    } else if (!ticketToEdit) {
      handlePrimaryButtonDisabling(false)
      if (roles?.includes(ADMIN)) {
        setAssignValue(defaultAssignValue)
      }
    }
  }, [isTicketModalOpen])

  useEffect(() => {
    if (
      isLoading ||
      isTicketByIdLoading ||
      (!!ticketToEdit && ticketById?.ticket?.id !== ticketToEdit) ||
      primaryButtonIsDisabled === undefined
    ) {
      setActiveTab(undefined)
    } else {
      setActiveTab('1')
    }
  }, [isLoading, isTicketByIdLoading, roles, ticketToEdit, ticketById, primaryButtonIsDisabled])

  useEffect(() => {
    if (!noteContent) {
      formNotes.setFieldsValue({ note: undefined })
    }
  }, [noteContent])

  useEffect(() => {
    if (form) {
      setFormInstance(form)
    }
    return () => {
      setFormInstance(undefined)
    }
  }, [form])

  return isTicketModalOpen ? (
    <StyledModal
      afterClose={handleAfterModalClose}
      destroyOnClose
      keyboard
      maskClosable
      className={`edit-modal ${!!(ticketById && !editable) && 'detail-modal'} admin-modal`}
      open={isTicketModalOpen}
      onCancel={handleCloseModal}
      title={<DinamicTitle>{ticketModalHeader()}</DinamicTitle>}
      closeIcon={<CloseOutlined />}
      cancelText={t('suppliers_router.new_ticket_modal.cancelText')}
      footer={
        !roles?.includes(ADMINRO) && [
          <Button key="cancelar" onClick={handleCloseModal} target="closeModalButton">
            {t('suppliers_router.new_ticket_modal.cancelText')}
          </Button>,
          <Button
            type="primary"
            key="ok"
            onClick={proceed}
            disabled={!activeTab || primaryButtonIsDisabled}
          >
            {!!ifToApproved
              ? t('suppliers_router.new_ticket_modal.authorize')
              : t('suppliers_router.new_ticket_modal.okText')}
          </Button>,
          roles?.includes(ADMIN) &&
            !!(
              ticketById &&
              canAdminDeleteTicket(ticketById?.ticket?.status?.name as StatusTicketEnum)
            ) && (
              <Button
                onClick={() => setIsDeleteTicketModalOpen(true)}
                key="eliminar"
                type="primary"
                danger
                ghost
              >
                {t('ticket_modal.button_delete')}
                <DeleteTwoTone twoToneColor="#cc3c37" />
              </Button>
            ),
        ]
      }
    >
      {!!activeTab ? (
        <div style={{ position: 'relative' }}>
          {isLoading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
              }}
            >
              <Spin size="large" />
            </div>
          )}
          <Tabs
            activeKey={activeTab}
            onTabClick={activeKey => {
              setActiveTab(activeKey as TabValue)
            }}
            items={[
              {
                label: t('ticket_modal.tab_info'),
                children: (
                  <UpdateTicketFormAdmin
                    ticket={ticketById?.ticket ?? ({} as Ticket)}
                    handlePrimaryButtonDisabling={handlePrimaryButtonDisabling}
                    editable={editable}
                    setEditable={setEditable}
                    dates={dates}
                    setDates={setDates}
                    roles={roles!}
                    isWarning={isWarning}
                    setIsWarning={setIsWarning}
                    ifToApproved={ifToApproved}
                    form={form}
                    setAssignValue={setAssignValue}
                    assignValue={assignValue}
                    carrierAvailabilityIsEnabled={carrierAvailabilityIsEnabled}
                    maxAllowedDaysForSupplierRequest={maxAllowedDaysForSupplierRequest}
                    isModalOpen={isTicketModalOpen}
                    cutoffTime={cutoffTime}
                  />
                ),
                key: '1',
              },
              ...(ticketById?.ticket && adminRoles.some(role => roles?.includes(role))
                ? [
                    {
                      label: `${t('ticket_modal.tab_notes')}${
                        ticketById?.ticket?.notes?.length
                          ? `(${ticketById.ticket.notes.length})`
                          : ''
                      }`,
                      children: (
                        <>
                          {roles?.includes(ADMINRO) ? null : (
                            <Form form={formNotes} className="note-input-form">
                              <StyledRow className="new-ticket-form-row comments">
                                <Form.Item label={t('globals.generics.note')} name="note">
                                  <TextArea
                                    onChange={handleSetNoteContent}
                                    value={noteContent}
                                    maxLength={1200}
                                    rows={3}
                                    allowClear
                                  />
                                </Form.Item>
                              </StyledRow>
                              <StyledButton
                                className={`add-note ${!noteContent && 'disabled'}`}
                                disabled={!noteContent}
                                onClick={handleAddNote}
                              >
                                {t('ticket_modal.add_note')}
                              </StyledButton>
                            </Form>
                          )}
                          {ticketById?.ticket?.notes?.map((note: Note) => (
                            <NoteElement data={note} />
                          ))}
                        </>
                      ),
                      key: '2',
                    },
                  ]
                : []),
            ]}
          />
        </div>
      ) : (
        <FlexRow className="ticket-modal-spin-container">
          <Spin className="ticket-modal-spinner" size="large" />
        </FlexRow>
      )}
    </StyledModal>
  ) : null
}
export default UpdateTicketModalAdmin
